import { render, staticRenderFns } from "./batchAnno.vue?vue&type=template&id=3b2cf561&scoped=true&"
import script from "./batchAnno.vue?vue&type=script&lang=js&"
export * from "./batchAnno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cf561",
  null
  
)

export default component.exports